import { app } from '../../../app';
import { Controller } from './st-export.controller';

app.component('stExport', {
    bindings: {
        name: '<',
        fields: '<',
        template: '<'
    },
    controller: Controller,
    require: {stTable: '^'},
    templateUrl: require('./st-export.html')
});



// WEBPACK FOOTER //
// ./src/portal/components/smart-table/export/st-export.component.js